import {useTranslation} from 'react-i18next';

import {Box, Button, ListItemButton, Typography, useTheme} from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';

import {AppHeaderWrapper} from '../AppHeaderWrapper';
import {SideDrawerWrapper} from '../SideDrawerWrapper';

import {FlagLanguageSwitcher} from '../../../LanguageSwitcher/FlagLanguageSwitcher';

const B2B_HEADER_KEYS = ['home', 'yourAdvantage', 'customerSatisfaction', 'faq'] as const;
const B2B_HEADER_LINKS: Record<(typeof B2B_HEADER_KEYS)[number], string> = {
  home: '#',
  yourAdvantage: '#your-advantage',
  customerSatisfaction: '#customer-satisfaction',
  faq: '#faq',
};

export const B2BHeader = () => {
  const {t} = useTranslation();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));

  if (isSmallScreen) {
    const menuItems = [
      ...B2B_HEADER_KEYS.map((key) => (
        <ListItemButton key={key} component='a' href={B2B_HEADER_LINKS[key]}>
          <Typography>{t(`b2b.header.${key}`)}</Typography>
        </ListItemButton>
      )),
      <FlagLanguageSwitcher key='language-switcher' />,
    ];
    return <SideDrawerWrapper sideBarSections={[{menuItems}]} />;
  }

  return (
    <AppHeaderWrapper isTransparent={false}>
      <Box sx={{display: {xs: 'none', md: 'flex', lg: 'flex'}, alignItems: 'center', gap: 1}}>
        {B2B_HEADER_KEYS.map((key) => (
          <Button key={key} component='a' href={B2B_HEADER_LINKS[key]} color='inherit' sx={{textTransform: 'none'}}>
            <Typography>{t(`b2b.header.${key}`)}</Typography>
          </Button>
        ))}
        <FlagLanguageSwitcher />
      </Box>
    </AppHeaderWrapper>
  );
};
